
import { useEffect } from "react";

import { useEditor } from "@craftjs/core";
import { Layers, useLayer } from "@craftjs/layers";
import { AccordionNavigationContainer, useAccordionContext } from "twyne-new.ui";

import { Item } from "./Item";
import Navigation from "./Navigation";

function Layer({ children }) {
  const { id, actions: { setExpandedState }, expanded, children: layerChildren, store: { actions: { toggleLayer } } } = useLayer(({ expanded }) => ({
    expanded,
  }));

  const { setActive } = useAccordionContext()

  const { name, selectedNodeId } = useEditor(({ nodes, events }) => {
    const [selectedNodeId] = events.selected;

    return {
      name: nodes[id] && nodes[id].data.name ? nodes[id].data.name : nodes[id].data.name,
      selectedNodeId,
    }
  });

  console.log({selectedNodeId})

  useEffect(() => {
    if (id === 'ROOT') {
      setExpandedState(true)
      setActive('ROOT')
    }
  }, [id, setExpandedState, setActive])

  useEffect(() => {
    if (selectedNodeId === id) {
      setActive(id)
    }
  }, [selectedNodeId, setActive, id])

  return <Item data={{ block: name, key: id }} onExpand={() => toggleLayer(id)}>
    {children && children.map(element => {
      const { id } = element.props
      return <Navigation key={id} id={id} value={expanded && layerChildren} onExpand={() => toggleLayer(id)}>
        {element}
      </Navigation>
    })}
  </Item>
}

export default function LayersSidebar() {
  return <AccordionNavigationContainer>
    <Navigation id='ROOT' value={['ROOT']}>
      <Layers renderLayer={Layer} expandRootOnLoad />
    </Navigation>
  </AccordionNavigationContainer>
}
